import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=066c6458&scoped=true&"
import script from "./ModalContainer.vue?vue&type=script&lang=js&"
export * from "./ModalContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModalContainer.vue?vue&type=style&index=0&id=066c6458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c6458",
  null
  
)

export default component.exports